import { computed, provide } from 'vue'
import useReactors from '@/__core__/composables/useReactors'
import useSize from '@/__core__/composables/useSize'
import { useThemeSizes } from '@/__v1.5__/composables/useThemeSizes'
import { isWidgetBranded } from '@/__core__/helpers/Common.helpers'

export function useWidgetContext({ containerRef, theme, size, widgetId, height, themeConfig, languageIdentifier, resizeFn, shouldResetSize }) {
  const { activeTheme, activeSize, activeHeightType, reorderedTabs } = useReactors(theme, size, { id: widgetId }, containerRef, height, themeConfig, 'latest')

  const isSmallWidget = computed(() => widgetWidth.value < 480)
  const isLargeWidget = computed(() => widgetWidth.value >= 640)
  const isAdaptiveHeight = computed(() => activeHeightType.value === 'fit-content')
  const branded = computed(() => isWidgetBranded(activeTheme.value))

  const { width: widgetWidth, height: widgetHeight, paddinglessWidth: widgetContainerPaddinglessWidth } = useSize(containerRef, activeSize, resizeFn, shouldResetSize, activeHeightType, branded)

  useThemeSizes(containerRef, widgetWidth)

  const heightClasses = computed(() => {
    if (activeHeightType?.value === 'fit-content') {
      return 'szw-h-auto szw-max-h-[none]'
    }

    return branded.value ? 'szw-max-h-[640px] szw-h-[640px]' : 'szw-h-[600px]'
  })
  const containerClasses = computed(() => [
    'szw-widget-container szw-core szw-relative szw-overflow-hidden',
    isLargeWidget.value ? 'szw-p-2 szw-gap-2' : 'szw-p-1 szw-gap-1',
    heightClasses.value
  ])

  const buttonOffset = computed(() => (isLargeWidget.value ? 16 : 8))

  provide('activeTheme', activeTheme)
  provide('activeSize', activeSize)
  provide('height', widgetHeight)
  provide('width', widgetWidth)
  provide('langId', languageIdentifier)
  provide('isSmallWidget', isSmallWidget)
  provide('isLargeWidget', isLargeWidget)
  provide('themeVersion', 'latest')

  return {
    langId: languageIdentifier,
    activeTheme,
    activeSize,
    widgetHeight,
    widgetWidth,
    containerClasses,
    isSmallWidget,
    reorderedTabs,
    branded,
    isAdaptiveHeight,
    isLargeWidget,
    buttonOffset,
    widgetContainerPaddinglessWidth
  }
}
